import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppComponent} from '../../app.component';

import {Constants} from '../../constants/ebtq-constants';
@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  // image = require('../../../assets/images/FannieMae.svg').default;
  // ebtqMainImage = require('../../../assets/images/ebmainpage.gif').default;
  appComponent:AppComponent;
  //isSystemBannerAvail:any;
  systemBannerMsg: string;
  //isServicingDeliveryAvail: any;
  servicingDeliveryMsgAvail: string;

  constructor(appComponent:AppComponent) {
    this.appComponent = appComponent;
    this.appComponent.header = false;

  }

  ngOnInit(): void {
    sessionStorage.setItem('currentSubMenuOption', '');
    sessionStorage.setItem('currentmenuOption', 'home');

    this.systemBannerMsg = sessionStorage.getItem(Constants.SYSTEM_MESSAGE) ?? '';
    this.servicingDeliveryMsgAvail = sessionStorage.getItem(Constants.RM_MonthEndProcIndicatorMsg) ?? '';

  }

  ngOnDestroy():void {
    this.appComponent.header = true;
  }

}
